import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';
import {Language} from '../enums/Language';
import {FormGroup} from '@angular/forms';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) { }

  public login(loginForm: FormGroup): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/v1/auth/signin`, {
      email: loginForm.controls.loginEmail.value,
      password: loginForm.controls.loginPassword.value,
    }, httpOptions);
  }

  public register(registerForm: FormGroup, currentLang: Language): Observable<any> {
    return this.http.post(`${environment.backendApiUrl}/v1/auth/signup`, {
      email: registerForm.controls.registerEmail.value,
      phone: registerForm.controls.phone.value.e164Number,
      firstname: registerForm.controls.firstname.value,
      lastname: registerForm.controls.lastname.value,
      password: registerForm.controls.registerPassword.value,
      passwordConfirm: registerForm.controls.passwordConfirm.value,
      socialProvider: 'LOCAL',
      language: currentLang,
      confirmed: registerForm.controls.confirmed.value
    }, httpOptions);
  }
}
